<app-standard-section-layout [title]="'What\'s on'">

        @if ((whatsOnData$ | async); as whatsOnData) {
            <div class="
                grid
                grid-cols-1
                md:grid-cols-3
                lg:grid-cols-4
                gap-4
                ">
                @for (item of whatsOnData.resultList; track item.id) {
                    <a class="block border rounded-lg p-5 cursor-pointer hover:border-slate-800 transition"
                        [routerLink]="['/edition', item.id]"
                    >
                        <h3 class="mb-1">{{ item.name }}</h3>
                        <p class="text-lg text-gray-800 mb-3">{{ item.seriesName }}</p>
                        <p class="text-base text-gray-600">
                            {{ formatFromToDate(item.from, item.to) }}
                        </p>
                    </a>
                }
            </div>
        }
        @else {
            <div class="px-6 py-8">
                <span class="text-base bg-slate-100 border-1 border-slate-300 py-2 px-5 rounded-full">Loading</span>
            </div>
        }

</app-standard-section-layout>
